import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { addSuppressedu5jwjfvsc039 as addSuppressed } from '../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { SafeCollector3ss0wp8n80f6m as SafeCollector } from './internal/SafeCollector.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function onCompletion(_this__u8e3s4, action) {
  // Inline function 'kotlinx.coroutines.flow.internal.unsafeFlow' call
  return new (onCompletion$$inlined$unsafeFlow$1())(_this__u8e3s4, action);
}
function *_generator_invokeSafely__rlho0m(_this__u8e3s4, action, cause, $completion) {
  try {
    var tmp = action(_this__u8e3s4, cause, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      if (!(cause === null) && !(cause === e)) {
        addSuppressed(e, cause);
      }
      throw e;
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function invokeSafely(_this__u8e3s4, action, cause, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_invokeSafely__rlho0m.bind(VOID, _this__u8e3s4, action, cause), $completion);
}
var ThrowingCollectorClass;
function ThrowingCollector() {
  if (ThrowingCollectorClass === VOID) {
    class $ {
      constructor(e) {
        this.d1h_1 = e;
      }
      b1h(value, $completion) {
        throw this.d1h_1;
      }
      s1d(value, $completion) {
        return this.b1h((value == null ? true : !(value == null)) ? value : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'ThrowingCollector', VOID, VOID, [FlowCollector()], [1]);
    ThrowingCollectorClass = $;
  }
  return ThrowingCollectorClass;
}
function ensureActive(_this__u8e3s4) {
  if (_this__u8e3s4 instanceof ThrowingCollector())
    throw _this__u8e3s4.d1h_1;
}
function *_generator_collect__dlomyy($this, collector, $completion) {
  try {
    var tmp = $this.e1h_1.b1d(collector, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } catch ($p) {
    if ($p instanceof Error) {
      var e = $p;
      var tmp_0 = invokeSafely(new (ThrowingCollector())(e), $this.f1h_1, e, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      throw e;
    } else {
      throw $p;
    }
  }
  // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$1 = $completion.rc();
  var sc = new (SafeCollector())(collector, tmp$ret$1);
  try {
    var tmp_1 = $this.f1h_1(sc, null, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }finally {
    sc.fd();
  }
  return Unit_instance;
}
var onCompletion$$inlined$unsafeFlow$1Class;
function onCompletion$$inlined$unsafeFlow$1() {
  if (onCompletion$$inlined$unsafeFlow$1Class === VOID) {
    class $ {
      constructor($this_onCompletion, $action) {
        this.e1h_1 = $this_onCompletion;
        this.f1h_1 = $action;
      }
      t1d(collector, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_collect__dlomyy.bind(VOID, this, collector), $completion);
      }
      b1d(collector, $completion) {
        return this.t1d(collector, $completion);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, VOID, [1]);
    onCompletion$$inlined$unsafeFlow$1Class = $;
  }
  return onCompletion$$inlined$unsafeFlow$1Class;
}
//region block: exports
export {
  ensureActive as ensureActive17z6c489wymmv,
  onCompletion as onCompletion2zzj1m13j2omp,
};
//endregion

//# sourceMappingURL=Emitters.mjs.map
